exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlay {\n  width: 100%;\n  height: 100%;\n  padding: 180px 0;\n  background-color: rgba(183,237,212,0.7);\n  position: absolute;\n  z-index: 999;\n  left: 0;\n  top: 0;\n}\n.overlay .ant-spin .anticon-loading {\n  filter: none;\n}\n.overlay .icon {\n  color: #1dbe72;\n  font-size: 45px;\n}\n", ""]);

